import _ from 'lodash'
import { Col, Row } from 'antd'
import { connect } from 'react-redux'
import { formValueSelector, FormSection } from 'redux-form'
import { required } from 'redux-form-validators'
import moment from 'moment'
import { CustomDisclaimer, ProposalBlock, ProposalSection, Tip } from '@vzmi/shp_shared_compo'
import { Field } from '../../../Common/forms'
import { CheckboxInputField, DateTimePickerField } from '../../../Common/Form'
import { UPDATE_LISTING_FORM_KEY } from '../../../../constants/proposalTypes'
import { DATE_FORMAT } from '../../../../lib/MomentHelper'
import styles from './index.css'
import useOnInit from '../../hook/useOnInit'

export const SECTION = 'scheduled'

export const FIELD = {
  IS_SCHEDULED: 'isScheduled',
  EXECUTE_TS: 'executeTs',
  IS_REVERT: 'isRevert',
  REVERT_TS: 'revertTs'
}

export const BATCH_PROPOSAL_TYPE = {
  EXECUTE: 'execute',
  REVERT: 'revert'
}

const INIT_STATE = {
  [FIELD.IS_SCHEDULED]: false,
  [FIELD.EXECUTE_TS]: moment().add(150, 'minute'),
  [FIELD.IS_REVERT]: false,
  [FIELD.REVERT_TS]: moment().add(210, 'minute')
}

export const getScheduledFromBatch = (batch) => {
  const batchId = _.get(batch, 'id')
  if (_.isUndefined(batchId)) {
    return INIT_STATE
  }

  const executeTs = _.get(batch, FIELD.EXECUTE_TS)
  const revertTs = _.get(batch, FIELD.REVERT_TS)
  const scheduled = {
    [FIELD.IS_SCHEDULED]: !_.isUndefined(executeTs),
    [FIELD.EXECUTE_TS]: moment(executeTs),
    [FIELD.IS_REVERT]: !_.isUndefined(revertTs),
    [FIELD.REVERT_TS]: moment(revertTs)
  }
  return scheduled
}

export const getGAReservation = (scheduled = {}) => {
  const {
    [FIELD.IS_SCHEDULED]: isScheduled,
    [FIELD.IS_REVERT]: isRevert
  } = scheduled

  if (isScheduled && isRevert) {
    return '3'
  }

  if (isRevert) {
    return '2'
  }

  if (isScheduled) {
    return '1'
  }

  return '0'
}

const ScheduledDisclaimer = () => {
  return (
    <CustomDisclaimer
      title='預約修改與回檔說明'
      detailsVisible
    >
      <ol className={styles.disclaimerContent}>
        <li>
          由於提案和審核過程中會有時間差，可能造成賣場/商品圖片的舊圖和目前線上圖片已不相同，遇此情況系統仍會執行提案單內新圖的內容。
        </li>
        <li>
          預約換圖及自動回檔的時間僅代表系統批次開始執行的時間，不代表換圖/回檔執行完成的時間，最久大約10分鐘內可執行完成。(例如：預約10:00的換圖，將可預期最晚會在10:10前完成換圖)
        </li>
        <li>
          若設定自動回檔，將以提案當時賣場/商品之圖片進行回檔。
        </li>
        <li>
          若未設定「預約修改圖片提案執行時間」，即表示立即執行; 可僅設定自動回檔，即表示立刻執行圖片修改，回檔時間到自動恢復。
        </li>
      </ol>
    </CustomDisclaimer>
  )
}

const ScheduledBlock = (props) => {
  const {
    scheduled = {},
    readOnly,
    change
  } = props

  const init = (values = INIT_STATE) => {
    change(SECTION, values)
  }

  const onIsScheduledChange = (e, isChecked) => {
    if (isChecked) {
      return
    }

    init()
  }

  const onIsRevertChange = (e, isChecked) => {
    if (isChecked) {
      return
    }

    init({
      ...scheduled,
      ..._.pick(INIT_STATE, [FIELD.IS_REVERT, FIELD.REVERT_TS])
    })
  }

  useOnInit(() => {
    if (readOnly) {
      return
    }

    init()
  }, [])

  return (
    <FormSection name={SECTION}>
      <ProposalSection>
        <ProposalBlock>
          <Row gutter={[0, 16]}>
            <Col span={6}>
              <Field
                name={FIELD.IS_SCHEDULED}
                component={CheckboxInputField}
                onChange={onIsScheduledChange}
                label='預約修改圖片提案執行時間'
                disabled={readOnly}
              />
            </Col>
            <Col
              className={styles.datepicker}
              span={18}
            >
              {scheduled[FIELD.IS_SCHEDULED] && (
                <>
                  <Field
                    name={FIELD.EXECUTE_TS}
                    component={DateTimePickerField}
                    validate={required('請選擇時間')}
                    displayFormat={DATE_FORMAT.SCHEDULE}
                    disabledDate={current => {
                      if (current) {
                        return current < moment().startOf('day') || current > moment().add(30, 'days')
                      }
                      return false
                    }}
                    placeholder='選擇預約執行時間'
                    disabled={readOnly}
                    showErrorOnActive
                    mustShowFormError
                    absoluteError
                    showTime
                  />
                  <Tip type='info'>
                    最短可預約下 2 個小時，最長可預約提案日 +1 個月
                  </Tip>
                </>
              )}
            </Col>
            <Col span={6}>
              <Field
                name={FIELD.IS_REVERT}
                component={CheckboxInputField}
                onChange={onIsRevertChange}
                label='設定自動回檔'
                disabled={readOnly}
              />
            </Col>
            <Col
              className={styles.datepicker}
              span={18}
            >
              {scheduled[FIELD.IS_REVERT] && (
                <>
                  <Field
                    name={FIELD.REVERT_TS}
                    component={DateTimePickerField}
                    validate={required('請選擇時間')}
                    displayFormat={DATE_FORMAT.SCHEDULE}
                    disabledDate={current => {
                      if (current) {
                        return current < moment().startOf('day') || current > moment().add(60, 'days')
                      }
                      return false
                    }}
                    placeholder='選擇回檔時間'
                    disabled={readOnly}
                    showErrorOnActive
                    mustShowFormError
                    absoluteError
                    showTime
                  />
                  <Tip type='info'>
                    以現在賣場圖片進行回檔；須晚「預約執行時間」15分鐘，最短可預約下 3 個小時，最長可預約提案日 +2 個月
                  </Tip>
                </>
              )}
            </Col>
            <Col span={24}>
              <ScheduledDisclaimer />
            </Col>
          </Row>
        </ProposalBlock>
      </ProposalSection>
    </FormSection>
  )
}

const selector = formValueSelector(UPDATE_LISTING_FORM_KEY)
const ScheduledBlockForm = connect(state => {
  const scheduled = selector(state, SECTION) || {}
  return { scheduled }
})(ScheduledBlock)

export default ScheduledBlockForm
